module.exports = __webpack_public_path__ + "img/filter.747deee4.svg";